<template>
  <div class="order">
    <Header :order="order.Номер" :date="order.Дата" isOrder />

    <div class="wrapper">
      <div class="order__info">
        <div class="container">
          <ul class="order__info-list">
            <li class="order__info-item order__info-item--nested">
              <div class="order__info-inner">
                <span class="order__info-header">№ заказа</span>
                <span class="order__info-value">{{ order.Номер | number }}</span>
              </div>
              <div class="order__info-inner">
                <span class="order__info-header">Время</span>
                <span class="order__info-value">{{ order.ВремяДоставки | time }}</span>
              </div>
              <div class="order__info-inner">
                <span class="order__info-header">Телефон</span>
                <a class="order__info-value" :href="'tel:'+order.ТелефонСсылка">{{ order.Телефон }}</a>
              </div>
            </li>
            <li class="order__info-item">
              <div class="order__info-inner">
                <span class="order__info-header">Клиент</span>
                <span class="order__info-value">{{ order.Клиент }}</span>
              </div>
            </li>
            <li class="order__info-item">
              <div class="order__info-inner">
                <span class="order__info-header">Адрес</span>
                <span class="order__info-value">{{ order.АдресДоставки }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="order__detail">
        <div class="container">
          <ul>
            <li class="order__detail-item">
              <span class="order__detail-gray">Номенклатура</span>
              <span class="order__detail-gray order__detail-right">Кол-во</span>
            </li>
            <li class="order__detail-item" v-for="(dish, dishIndex) in order.Товары" :key="dishIndex">
              <p class="order__detail-left">{{ dish.Номенклатура }}</p>
              <p class="order__detail-right order__detail-count">
                <span>{{ dish.Количество }}</span>
              </p>
            </li>            
            <li class="order__detail-overall">
              <p class="order__detail-gray order__detail-sum">Сумма</p>
              <p class="order__detail-right"><b>{{ order.Сумма }}</b></p>
            </li>
          </ul>  
        </div>  
      </div>
      <div class="payment">
        <div class="container">
          <div class="payment__items">
            <div class="payment__item">
              <div class="payment__item-head">
                Оплата
              </div>
              <div class="payment__item-check" v-for="(pay, payIndex) in payment" :key="payIndex" :disabled="order.ЗаказВыдан || order.ЗапретИзмененияВидаОплаты">
                <label class="radio">
                  <input type="radio" name="payment" v-model="payType" :value="payIndex" :disabled="order.ЗаказВыдан || order.ЗапретИзмененияВидаОплаты">
                  <div class="radio__text" :class="{ 'error-radio': !validation.payment }">{{ pay }}</div>
                </label> 
              </div>
            </div>
            <div class="payment__item">
              <div class="payment__item-head">
                Отправка чека
              </div>
              <div class="payment__item-check" v-for="(rec, recIndex) in receiptList" :key="recIndex" :disabled="order.ЗаказВыдан">
                <label class="radio">
                  <input type="radio" name="receipt" v-model="receipt" :value="recIndex" :disabled="order.ЗаказВыдан">
                  <div class="radio__text" :class="{ 'error-radio': !validation.receipt }">{{ rec }}</div>
                </label>
              </div>
            </div>
          </div>   
          <div class="payment__email" v-show="emailChecked">
            <input type="email" placeholder="Введите e-mail" class="email__input" v-model="email" :class="{ 'error-input': !validation.email }" :disabled="order.ЗаказВыдан">
          </div>    
          <div class="payment__email" v-show="smsChecked">
            <input type="text" placeholder="Введите номер телефона" class="email__input" v-model="phone" :class="{ 'error-input': !validation.phone }" :disabled="order.ЗаказВыдан" v-mask="{mask: '(999) 999-99-99'}">
          </div>    
          <div class="payment__button">
            <button class="payment__submit" @click="submitOrder" :disabled=order.ЗаказВыдан>
              <span v-if="!order.ЗаказВыдан">Выдать заказ</span>
              <span v-else>Заказ выдан</span>
            </button>
          </div>   
        </div>
      </div>    
    </div>

    <popup :is-opened="openPopup" @close-popup="openPopup = false" :title="popupTitle" :text="popupText"></popup>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Popup from '@/components/Popup.vue'

export default {
  name: 'Order',
  components: {
    Header,
    Popup
  },
  data () {
    return {
      checkout: false,
      receipt: '',      
      payTypeSet: '',
      phoneSet: '',
      emailSet: '',
      fields: {},
      payment: [
        'Платёжная карта',
        'Наличными'       
      ],     
      receiptList: [
        'На e-mail',
        'В SMS'
      ],
      openPopup: false,
			popupTitle: '',
			popupText: ''
    }
  },
  computed: {
    order () {
      return this.$store.state.order ? this.$store.state.order : {}
    },
    email: {
      get () {
        if (this.emailSet === '') {
          return this.order.АдресЭП ? this.order.АдресЭП : ''
        } else
        return this.emailSet
      },
      set (value) {
        if (value < 1) {
         return false 
        } else {
          this.emailSet = value  
        }
      }
    },
    phone: {
      get () {
        if (this.phoneSet === '') {
          let phone = this.order.ТелефонСсылка ? this.order.ТелефонСсылка : ''
          phone = phone.replace(/ |-|\(|\)|\+7/g, '')
          return phone
        } else
        return this.phoneSet
      },
      set (value) {
        if (value.length < 1) {
          return false
        } else {
          this.phoneSet = value
        }
      }
    },
    payType: {
      get () {
        if (this.payTypeSet === '') {
          return this.order.ВидОплаты == 'Наличные' ? 1 : this.order.ВидОплаты == 'Безналичные' ? 0 : ''
        } else
        return this.payTypeSet
      },
      set (value) {
        this.payTypeSet = value 
      }
    },
    emailChecked () { 
      return this.receipt === 0 ? true : false
    },
    smsChecked () { 
      return this.receipt === 1 ? true : false
    },
    validation () {
      const reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      const rePhone = /^\d+$/
    
      if (this.checkout) {
         return {
          payment: this.payType !== '',
          receipt: this.receipt !== '',
          email: this.emailChecked ? reEmail.test(this.email) && this.emailChecked : true,
          phone: !this.emailChecked ? rePhone.test(this.phone) && this.phone.length == 10 && !this.emailChecked : true
        }	
      } else {
         return  {
          payment: true,
          receipt: true,
          email: true,
          phone: true
        }
      }
		},
		isValid () {
			return Object.keys(this.validation).every((key) => {
				return this.validation[key]
			})
    }
  },
  filters: {
    time: value => {
      return !value ? '' : value.split('T')[1].slice(0, -3)
    },
    number: value => {
      return !value ? '' : value.split('-')[1]
    }
  },
  created () {
    this.$root.$on('popup', this.popupHandler)
  },
  methods: {
    popupHandler ({title,text}) {
			this.popupTitle = title
			this.popupText = text
			this.openPopup = true
    },
    submitOrder () {
      this.checkout = true
      this.fields = {
        sessionId: localStorage.getItem('sessionId'),
        orderId: this.$store.state.order_id,
        payment: this.payType ? 'Cash' : 'Card',
        email: this.emailChecked ? this.email : this.phone
      }
      if (this.isValid) {
        this.$store.dispatch('ORDER_DONE', this.fields) 
          .then(
            (response) => {
              if (response.status === 200) {
                this.$router.push('/orders')
              } else if (response.status === 400) {
                this.$root.$emit('popup', {title: 'Ошибка', text: response.data.ОписаниеОшибки })
              }		
            },
            (err) => {
              this.$root.$emit('popup', {title: 'Ошибка', text: 'Ошибка загрузки' })
              throw new Error(err)
            }
          )
          .catch (err => {
            this.$root.$emit('popup', {title: 'Ошибка', text: 'Ошибка загрузки'})
            // eslint-disable-next-line
            console.log(err);
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 350px) {
  /deep/ .header__info {
    font-size: 18px;
  }
}
.wrapper {
  width: 100%;
  margin: 0px auto;
  background-color: #fff;
}
.container {
  margin: 0 10px;
}
.order {
  min-height: 100vh;
  background-color: #f2f2f2;
  &__info {
    background-color: #f2f2f2;
    &-item {
      padding: 12px 10px;
      border-bottom: 1px solid #cacaca;
      &--nested {
        display: flex;
        justify-content: space-between;
      }
    }
    &-inner {
      display: flex;
      flex-direction: column;
    }
    &-header {
      color: #cacaca;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 4px;
    }
    &-value {
      font-size: 14px;
      line-height: 16px;
    }
  }
  &__detail {
    background-color: #fff;
    font-size: 14px;
    &-item {
      padding: 12px 10px 10px;
      border-bottom: 1px solid #ddd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:last-of-type {
        border-bottom: 1px solid #000;
      }  
    }
    &-right {
      width: 60px;
    }
    &-left {
      width: calc(100% - 70px);
      margin-right: 10px;
    }
    &-count {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-gray {
      color: #7e7e7e;
    }
    &-overall {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 10px 10px;
      border-top: 1px solid #000;   
      position: relative;
      top: -1px;   
    }
    &-sum {
      text-align: right;
      width: calc(100% - 86px);
      margin-right: 26px;
    }
  }
}
.payment {
  background-color: #f2f2f2;
  &__items {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  &__item {
    width: calc(50% - 10px);
    &-check {
      margin-bottom: 16px;
      margin-left: 10px;
      white-space: nowrap;
    }
    &-head {
      padding: 14px 10px 13px;
      color: #7e7e7e;
      margin-bottom: 17px;
      font-size: 14px;
      border-bottom: 1px solid #cacaca;
    }
  }
  &__email {
    margin: 0 10px 24px;
  }
  &__button {
    margin: 0 10px;
    padding-bottom: 25px;
  }
  &__submit {
    font-family: $akrobat;
    color: #fff;
    font-size: 18px;
    text-transform: uppercase;
    width: 100%;
    text-align: center;
    padding: 14px 0 13px;
    border-radius: 50px;
    background-color: $green;
    cursor: pointer;
    &:active {
      transform: scale(0.98);
    }
  }
}
.email__input {
  background-color: #f2f2f2;
  width: 100%;
  padding: 7px 10px;
  margin: 0;
  outline: none;
  border: none;
  border-bottom: 1px solid #000;
  color: #000;
  font-size: 16px;
  font-family: $font-base;
}
.error-input {
  border-bottom: 1px solid $red;
}
.error-radio::before {
  box-shadow: 0px 0px 7px $red;
}
</style>
